<div class="cadastro-tradutor-container">
  <div class="header">
    <h1>Cadastro de Tradutores</h1>
    <button class="btn btn-primary" (click)="openModal(formModal, true)">Novo Tradutor</button>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroCpf">CPF:</label>
          <input 
            type="text" 
            id="filtroCpf" 
            class="form-control" 
            [(ngModel)]="filtroCpf"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por CPF">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroTraducao">Tipo de Tradução:</label>
          <select 
            id="filtroTraducao" 
            class="form-control" 
            [(ngModel)]="filtroTraducao"
            (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="traD_ITALIANO_PORTUGUES">Italiano-Português</option>
            <option value="traD_PORTUGUES_ITALIANO">Português-Italiano</option>
            <option value="traD_OUTRAS">Outras</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroJuramentado">Juramentado:</label>
          <select 
            id="filtroJuramentado" 
            class="form-control" 
            [(ngModel)]="filtroJuramentado"
            (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-end">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>CPF</th>
          <th>E-mail</th>
          <th>Telefone</th>
          <th>Traduções</th>
          <th>Juramentado</th>
          <th>Data Cadastro</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tradutor of tradutoresFiltrados">
          <td>{{ tradutor.nome }}</td>
          <td>{{ tradutor.cpf }}</td>
          <td>{{ tradutor.email }}</td>
          <td>{{ tradutor.telefone }}</td>
          <td>
            <span *ngIf="tradutor.traD_ITALIANO_PORTUGUES" class="badge bg-primary me-1">Italiano-Português</span>
            <span *ngIf="tradutor.traD_PORTUGUES_ITALIANO" class="badge bg-success me-1">Português-Italiano</span>
            <span *ngIf="tradutor.traD_OUTRAS" class="badge bg-info">Outras</span>
          </td>
          <td>
            <span class="badge" [ngClass]="tradutor.juramentado == 'S' ? 'bg-success' : 'bg-warning'">
              {{ tradutor.juramentado == "S" ? 'Sim' : 'Não' }}
            </span>
          </td>
          <td>{{ tradutor.datA_CADASTRO | date:'dd/MM/yyyy' }}</td>
          <td>
            <button class="btn btn-sm btn-warning me-2" (click)="editarTradutor(tradutor); openModal(formModal)">
              <i class="fa fa-edit"></i> Editar
            </button>
            <!--<button class="btn btn-sm btn-danger" (click)="excluirTradutor(tradutor.id)">
              <i class="fa fa-trash"></i> Excluir
            </button>-->
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal -->
  <ng-template #formModal>
    <div class="modal-header">
      <h4 class="modal-title">{{ tradutorSelecionado ? 'Editar Tradutor' : 'Novo Tradutor' }}</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="cadastroForm" (ngSubmit)="onSubmit()" class="form-container">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nomeCompleto">Nome completo:</label>
              <input 
                type="text" 
                id="nomeCompleto" 
                formControlName="nomeCompleto" 
                class="form-control"
                placeholder="Digite o nome completo">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="cpf">CPF:</label>
              <input 
                type="text" 
                id="cpf" 
                formControlName="cpf" 
                class="form-control"
                placeholder="000.000.000-00"
                [textMask]="{mask: cpfMask}">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="email">E-mail:</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="form-control"
                placeholder="seu@email.com">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="telefone">Telefone:</label>
              <input 
                type="text" 
                id="telefone" 
                formControlName="telefone" 
                class="form-control"
                placeholder="(00) 00000-0000"
                [textMask]="{mask: telefoneMask}">
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="endereco">Endereço completo:</label>
          <textarea 
            id="endereco" 
            formControlName="endereco" 
            class="form-control"
            placeholder="Digite o endereço completo"
            rows="3"></textarea>
        </div>

        <div class="form-group checkbox-group">
          <label class="mb-2">Tipos de Tradução:</label>
          <div class="row">
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="itaPor" formControlName="ITA_POR" class="form-check-input">
                <label for="itaPor" class="form-check-label">Italiano-Português</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="porIta" formControlName="POR_ITA" class="form-check-input">
                <label for="porIta" class="form-check-label">Português-Italiano</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check">
                <input type="checkbox" id="out" formControlName="OUT" class="form-check-input">
                <label for="out" class="form-check-label">Outras</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="cadastroForm.get('OUT')?.value">
          <label for="outrasTraducoes">Informar outras traduções:</label>
          <textarea 
            id="outrasTraducoes" 
            [(ngModel)]="outrasTraducoes" 
            [ngModelOptions]="{standalone: true}"
            class="form-control"
            placeholder="Digite as outras línguas que você traduz"
            rows="2"></textarea>
        </div>

        <div class="form-group checkbox-group mt-4">
          <label class="mb-2">Juramentado:</label>
          <div class="row">
            <div class="col-md-6">
              <div class="form-check">
                <input type="radio" id="juramentadoSim" formControlName="juramentado" [value]="true" class="form-check-input">
                <label for="juramentadoSim" class="form-check-label">Sim</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check">
                <input type="radio" id="juramentadoNao" formControlName="juramentado" [value]="false" class="form-check-input">
                <label for="juramentadoNao" class="form-check-label">Não</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="modalRef.dismiss()">Cancelar</button>
          <button type="submit" class="btn btn-primary ms-2" [disabled]="!cadastroForm.valid">Salvar</button>
        </div>
      </form>
    </div>
  </ng-template>
</div> 